<template>
    <section
        v-if="content"
        class="c-case-study-body"
    >
        <y-row>
            <y-col
                v-if="contentText"
                class="c-case-study-body__text"
                md="9"
            >
                <y-page-content
                    v-if="contentText"
                    :content="contentText"
                />
            </y-col>
            <y-col md="3">
                <div
                    v-if="isAnyValueTruthy(customerInfo)"
                    class="c-case-study-body__custom"
                >
                    <div
                        v-for="(info, infoTitle) in customerInfo"
                        :key="infoTitle"
                        class="case-study-customer-info"
                    >
                        <h6
                            v-if="info && infoTitle"
                            class="case-study-customer-info__title"
                        >
                            {{ $t(`case-studies.customer.${infoTitle}`) }}
                        </h6>
                        <span
                            v-if="info && infoTitle"
                            class="case-study-customer-info__description"
                        >
                            {{ info }}
                        </span>
                    </div>

                    <div class="customer-social-wrapper">
                        <y-socials
                            size="normal"
                            :share="share"
                            squared
                            color="body"
                        />
                    </div>

                    <a
                        v-if="albums && albums[0]['link']"
                        class="case-study-customer-action"
                        :href="albums[0]['link']"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <y-button
                            tag="button"
                            :content="$t('case-studies.download_button')"
                            color="primary"
                            size="medium"
                            flat
                            :no-padding="false"
                        />
                    </a>
                </div>
            </y-col>
        </y-row>
    </section>
</template>

<script>
    import { YSocials, YPageContent } from '@groot-components/all';

    export default {
        name      : 'CaseStudyBody',
        components: {
            YSocials,
            YPageContent,
        },
        props: {
            content: {
                type   : Object,
                default: () => {},
            },
            contentText: {
                type   : String,
                default: null,
            },
            albums: {
                type   : Array,
                default: () => [],
            },
        },

        computed: {
            /**
             * Return Share data
             *
             * @returns {object}
             */
            share() {
                return {
                    url  : window.location.href,
                    title: this.title,
                };
            },

            /**
             * Return case study info
             *
             * @returns {object}
             */
            customerInfo() {
                return {
                    customer_name: this.content['customer-name'],
                    industry     : this.content.industry,
                    region       : this.content.region,
                };
            },

        },
        methods: {
            /**
             * Return if object is empty or not
             *
             * @param {object} obj
             * @returns {boolean}
             */
            isAnyValueTruthy(obj) {
                return !!Object.values(obj).find((o) => !!o);
            },
        },

    };
</script>

<style lang="scss" src="./index.scss" />

